import React, { useContext } from 'react';
import { AppContext } from 'contexts';
import { makeStyles, Button, Typography, ListItem } from '@material-ui/core';
import CallEndIcon from '@material-ui/icons//CallEnd';
import { AgoraRTCClient } from 'utils/agora';

const useStyles = makeStyles((theme) => {
  return {
    row: {
      justifyContent: 'center',
      alignSelf: 'center',
    },
    reconnect: {
      marginRight: 20,
    },
    inSession: {
      marginRight: 20,
    },
    waiting: {
      height: 30,
      justifyContent: 'flex-start',
      paddingLeft: 0,
    },
  };
});
function AgoraCall() {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const { setDisplayHangupModal, isJoinedSession } = appContext;
  return (
    <div className={classes.row}>
      {isJoinedSession ? (
        <Button
          size='small'
          variant='contained'
          color='secondary'
          onClick={() => {
            setDisplayHangupModal(true);
          }}
        >
          <CallEndIcon />
        </Button>
      ) : (
        <ListItem className={classes.waiting}>
          <img
            src='/images/calling_blue_transparent.gif'
            alt='calling'
            height='40px'
            width='40px'
          />
          <Button
            size='small'
            variant='contained'
            color='secondary'
            onClick={() => {
              setDisplayHangupModal(true);
            }}
          >
            <CallEndIcon />
          </Button>
        </ListItem>
      )}
    </div>
  );
}
export default AgoraCall;
